import type { EntityNoticeParams } from './params'

/**
 * signup_modal_contextualized's SSR eligibility (usage=iframe + PF/CNPJ +
 * person/lawsuit segment) is satisfied by exactly the params the entity page
 * already sends. When the entity-notice fake door is active, this forces
 * exposure off regardless of that eligibility result, so getFeatureValue is
 * never called and Experiment.Participate never fires for the competing
 * experiment. Suppression depends only on entityNoticeParams — never on
 * signupModalEntityType — because the parent is expected to stop sending
 * signupModalEntityType in a later slice.
 */
export function suppressSignupModalExposure(
  eligibilityResult: boolean,
  entityNoticeParams: EntityNoticeParams | null
): boolean {
  if (entityNoticeParams) return false
  return eligibilityResult
}
